export enum ImageProperty {
  image_60px = 'image_60px',
  image_300px = 'image_300px',
}
